import { definePropType } from "@types-vue/props";
import { computed, defineComponent, ref } from "vue";
import PtCustomButton from "@com/components/pt-custom-button/index.vue";
export default defineComponent({
    props: {
        config: {
            type: definePropType(Array),
            required: true
        },
        data: {
            type: definePropType(Object)
        }
    },
    components: {
        PtCustomButton: PtCustomButton
    },
    setup: function setup(props) {
        var handleCommand = function handleCommand(option) {
            option.onClick && option.onClick(props.data);
        };
        var handleVisibleChange = function handleVisibleChange(visible) {
            active.value = visible;
        };
        var active = ref(false);
        var innerConfig = computed(function() {
            return props.config.filter(function(item) {
                return typeof item.visible === "undefined" || typeof item.visible === "boolean" && item.visible;
            });
        });
        return {
            active: active,
            handleCommand: handleCommand,
            handleVisibleChange: handleVisibleChange,
            innerConfig: innerConfig
        };
    }
});
